import { resolveImg } from "@/lib/api";

const IMG = "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/";
const STORE = "https://customer-assets-lqy194kg.emergentagent.net/job_bambam-shop/artifacts/";

export const ASSETS = {
  // Official Bambam logo (transparent PNGs in /public/brand)
  logo: "/brand/logo-full.png",
  logoMark: "/brand/logo-mark.png",
  logoWordmark: "/brand/logo-wordmark.png",
  legacyLogo: STORE + "6jesd7hp_bambam_logo.png",
  storefront: STORE + "qzukbato_1.jpeg",
  hero: STORE + "qzukbato_1.jpeg",
  groceries: STORE + "rifl278j_groceries.webp",
  spices: IMG + "ab1a07eef0451c09481cb8be5a9e05a32bdf62eee826eb9b70948aa41ae159e5.jpeg",
  grains: IMG + "ac07928285fbd965b0e34b5007b9c68f9298eee0b6a89a6cb0451951860c747c.jpeg",
  snacks: IMG + "e45ef5b732268009ef287bc3bb780b98261914c5fceba316a8e7a730a5f80787.jpeg",
  beverages: IMG + "e680be02f876cae5486ab1b6fd8235571ed71a880f1da4f89cef74e62ddce3ad.jpeg",
};

// Brand imagery & motion generated with Higgsfield for the redesign (/public/media)
export const MEDIA = {
  hero: "/media/hero.webp",
  heroSm: "/media/hero-sm.webp",
  heroVideo: "/media/hero-loop.mp4",
  delivery: "/media/delivery.webp",
  deliverySm: "/media/delivery-sm.webp",
  feast: "/media/feast.webp",
  feastSm: "/media/feast-sm.webp",
};

// Photorealistic default category photos (Higgsfield), used whenever a category has
// neither a Square image nor an admin-uploaded web image.
const CATEGORY_ART = {
  artifacts: "artifacts", beauty: "beauty", drink: "drinks", beverages: "drinks",
  dryfoods: "dry-foods", foodcooked: "cooked", foodcookedtribes: "cooked",
  foodsnack: "snacks", foodsnacks: "snacks", snacks: "snacks",
  fooduncooked: "produce", freshproduce: "produce",
  foodspice: "spices", spiceuncooked: "spices", spicesseasonings: "spices",
  hair: "hair", householditem: "household", sweet: "sweet",
  grainsflour: "grains", pantryoils: "pantry",
};

export function categoryArt(name) {
  const file = CATEGORY_ART[(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "")];
  return file ? `/media/categories/${file}.webp` : "";
}

export function categoryImage(c) {
  if (!c) return "";
  if (c.square_image || c.web_image) return resolveImg(c.image);
  return categoryArt(c.name) || resolveImg(c.image);
}

export const HERO_SLIDES = [
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/6ef7237879d3f3c2d860731d9940339e21bb1d3387357d8c1b5a36f56a68fbc3.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/9050da10cd1c0ac79fcee332376580a6aa47844af15c88e025f0e041884da4ec.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/2f8a5ea05cdd2fc0761395b1ff1015ecb9cc76ae959b42e85212a4ac81f8b26b.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/23f3bd9f05c4093e8dd4f91fcd80fbb1a6e211c0af8eeed231c12a423054a326.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/fc41942dcc8b736f10dfb041d2c33795e5fc0fe190b3ba268a899cbbbe0755d6.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/d30909f4-01bd-4058-b621-bea4ec0466ca/images/6cb14b0ddc4c04daafe8c95d140d1ebb80334498200e29e0c582b1fec3eaefd8.jpeg",
];

export const STORE_INFO = {
  address: "22 Midlake Blvd SE #518",
  city: "Calgary, AB T2X 2A2",
  phones: ["825-431-7969", "403-453-0023"],
  email: "hello@bambamafricanmart.com",
  hoursSummary: "Mon–Thu 10:30am–7:30pm · Fri 10am–8pm · Sat 9am–8pm · Sun 12–6pm",
  hours: [
    { d: "Monday", t: "10:30am – 7:30pm" },
    { d: "Tuesday", t: "10:30am – 7:30pm" },
    { d: "Wednesday", t: "10:30am – 7:30pm" },
    { d: "Thursday", t: "10:30am – 7:30pm" },
    { d: "Friday", t: "10:00am – 8:00pm" },
    { d: "Saturday", t: "9:00am – 8:00pm" },
    { d: "Sunday", t: "12:00pm – 6:00pm" },
  ],
  mapEmbed: "https://www.google.com/maps?q=22+Midlake+Blvd+SE+%23518%2C+Calgary%2C+AB+T2X+2A2&output=embed",
};

// Returns { open, label, today } based on Calgary (Mountain) time and STORE_INFO.hours.
function _toMinutes(str) {
  const m = str.trim().match(/(\d+):(\d+)\s*(am|pm)/i);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  const mer = m[3].toLowerCase();
  if (mer === "pm" && h !== 12) h += 12;
  if (mer === "am" && h === 12) h = 0;
  return h * 60 + min;
}

export function getStoreStatus() {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Edmonton", weekday: "long", hour: "2-digit", minute: "2-digit", hour12: false,
    }).formatToParts(new Date());
    const weekday = parts.find((p) => p.type === "weekday").value;
    let hour = parseInt(parts.find((p) => p.type === "hour").value, 10);
    if (hour === 24) hour = 0;
    const minute = parseInt(parts.find((p) => p.type === "minute").value, 10);
    const nowMin = hour * 60 + minute;
    const today = STORE_INFO.hours.find((h) => h.d === weekday);
    if (!today) return { open: false, label: "Closed", today: null };
    const [openStr, closeStr] = today.t.split(/[–-]/);
    const openMin = _toMinutes(openStr);
    const closeMin = _toMinutes(closeStr);
    const open = openMin != null && closeMin != null && nowMin >= openMin && nowMin < closeMin;
    return { open, label: open ? "Open now" : "Closed", today: today.t };
  } catch (e) {
    return { open: false, label: "", today: null };
  }
}

const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function _fmtMin(min) {
  let h = Math.floor(min / 60);
  const m = min % 60;
  const mer = h >= 12 ? "pm" : "am";
  let hh = h % 12;
  if (hh === 0) hh = 12;
  return `${hh}:${m.toString().padStart(2, "0")}${mer}`;
}

// Generates selectable pickup windows (2h) for the next few open days, respecting Calgary store hours.
export function getPickupSlots(maxDays = 5, windowMinutes = 120, leadMinutes = 60) {
  let weekdayName, nowMin;
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Edmonton", weekday: "long", hour: "2-digit", minute: "2-digit", hour12: false,
    }).formatToParts(new Date());
    weekdayName = parts.find((p) => p.type === "weekday").value;
    let hour = parseInt(parts.find((p) => p.type === "hour").value, 10);
    if (hour === 24) hour = 0;
    nowMin = hour * 60 + parseInt(parts.find((p) => p.type === "minute").value, 10);
  } catch (e) {
    const d = new Date();
    weekdayName = WEEKDAYS[d.getDay()];
    nowMin = d.getHours() * 60 + d.getMinutes();
  }
  const startIdx = WEEKDAYS.indexOf(weekdayName);
  const slots = [];
  let daysAdded = 0;
  for (let off = 0; off < 7 && daysAdded < maxDays; off++) {
    const idx = (startIdx + off) % 7;
    const day = STORE_INFO.hours.find((h) => h.d === WEEKDAYS[idx]);
    if (!day) continue;
    const [openStr, closeStr] = day.t.split(/[–-]/);
    const openMin = _toMinutes(openStr);
    const closeMin = _toMinutes(closeStr);
    if (openMin == null || closeMin == null) continue;
    const dayLabel = off === 0 ? "Today" : off === 1 ? "Tomorrow" : WEEKDAYS[idx];
    let added = false;
    let s = openMin;
    // On the current day, start from the next window after the lead time.
    if (off === 0) {
      const earliest = nowMin + leadMinutes;
      while (s + windowMinutes <= closeMin && s < earliest) s += windowMinutes;
    }
    for (; s < closeMin; s += windowMinutes) {
      const e = Math.min(s + windowMinutes, closeMin);
      if (e - s < 30) break;
      slots.push({ value: `${dayLabel} · ${_fmtMin(s)} – ${_fmtMin(e)}`, day: dayLabel });
      added = true;
    }
    if (added) daysAdded++;
  }
  return slots;
}
